import { onMounted, onUnmounted, nextTick } from 'vue'
import { onEchartsThemeRefresh } from '@/utils/chart-theme-colors'

/** 主题切换后重新 setOption，避免饼图/折线图仍用旧主色 */
export function useEchartsThemeSync (rerender: () => void) {
  let unsubscribe: (() => void) | undefined

  onMounted(() => {
    unsubscribe = onEchartsThemeRefresh(() => {
      nextTick(rerender)
    })
  })

  onUnmounted(() => {
    unsubscribe?.()
  })
}
